import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import IconImageRequest from '../../../../../../../components/icons/icon-image-request/icon-image-request';
import FileUpload from '../../../../../../../components/file-upload/file-upload';
import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../../components/fonts/font-props';
import customizationStore from '../../../../../../../stores/customizations/customization-store';
import { Input } from '../../../../../../../components/inputs/input/input';
import React from 'react';
import { ButtonIcon } from '../../../../../../../components/inputs/button-icon/button-icon';
import IconDelete from '../../../../../../../components/icons/icon-delete/icon-delete';
import './image-preview.scss';
import './image-upload.scss';
import { S2E_LAYOUT_TYPE_MAP } from '../../../../../../../models/User';
import { isSet } from '../../../../../../../models/model-types-methods';

interface IProps {
	index: number;
}

const LayoutItemFormGroup: React.FC<IProps> = ({ index }) => {

	const activeCustomizationStore = customizationStore.getSelectedStore();

	const layoutType = activeCustomizationStore.switchToExchangeLayoutType;
	const layoutItemStore = activeCustomizationStore.switchToExchangeLayoutData?.[index];

	const setLayoutItemLink = (value: string) => activeCustomizationStore.setSwitchToExchangeLayoutItemLink(index, value);
	const deleteLayoutItemImage = () => activeCustomizationStore.deleteSwitchToExchangeLayoutItemImage(index);
	const uploadLayoutItemImage = (fileData: File, fileContent: string) => {
		if (fileData && fileContent) {
			activeCustomizationStore.uploadSwitchToExchangeLayoutItemImage(index, fileData.type, fileContent.split(',')[1]);
		}
	};

	return (
		<>
			<div className="image-upload-container">
				{isSet(layoutType) && <FormFieldLine
					label={`Image ${index + 1}`}
					gridStyle={{ lableWidth: { width: 1 }, childrenWidth: { width: 2 } }}
				>
					<div>
						<div className="image-upload-input">
							<div className="upload-icon-container">
								<IconImageRequest color="var(--color-semantic-3)"/>
							</div>
							<FileUpload
								uploadFile={(fileData, fileContent) => uploadLayoutItemImage(fileData, fileContent as string)}
								buttonText={"Upload image"}
								readType="dataUrl"
								fileTypes={['image/jpeg', 'image/png', 'image/gif']}
								acceptedFileFormats=".jpg,.jpeg,.png,.gif"
								disabled={activeCustomizationStore.isSaving()}
							/>
						</div>
						<FontBody2 color={FONT_COLOR.NEUTRAL3}>
							Recommended aspect ratio: {S2E_LAYOUT_TYPE_MAP[layoutType!].imageAspectRatio}
						</FontBody2>
					</div>
				</FormFieldLine>}
				{
					activeCustomizationStore.switchToExchangeLayoutData?.[index]?.image && (
						<div className="image-preview-container">
							<FontBody2 color={FONT_COLOR.PRIMARY3_50}>
								Image size {activeCustomizationStore.switchToExchangeLayoutData[index].imageDimensions}
							</FontBody2>
							<div className="image">
								<img src={activeCustomizationStore.switchToExchangeLayoutData[index].image} alt=""/>
								<ButtonIcon
									Component={IconDelete}
									color="var(--color-accent-3)"
									onClick={deleteLayoutItemImage}
									disabled={activeCustomizationStore.isSaving()}
								/>
							</div>
						</div>
					)
				}
			</div>

			<FormFieldLine
				label="Destination URL"
				gridStyle={{ lableWidth: { width: 1 }, childrenWidth: { width: 2 } }}
			>
				<div>
					<Input
						required={false}
						value={layoutItemStore?.link}
						onChange={setLayoutItemLink}
					/>
					<FontBody2 color={FONT_COLOR.NEUTRAL3}>
						The page the image will direct to when clicked, such as a product page or collection. If left empty, customers will be directed to your home page
					</FontBody2>
				</div>
			</FormFieldLine>
		</>
	);
};

export default LayoutItemFormGroup;
